import { jsx as _jsx } from "react/jsx-runtime";
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { POSITIONS, Tooltip } from '@design-system/tooltip';
export const INFORMATION_TOOLTIP_SIZES = {
    NORMAL: '16px',
    SMALL: '12px',
};
export const InformationTooltip = ({ children, inline = false, maxWidth = 272, portalTarget, position = POSITIONS.TOP, size = INFORMATION_TOOLTIP_SIZES.NORMAL, }) => (_jsx(Tooltip, { childrenElement: children, fixedParent: Boolean(portalTarget), initialPosition: position, inline: inline, maxWidth: maxWidth, portalTarget: portalTarget, children: _jsx(FontAwesomeIcon, { color: "primary", height: size, iconName: "circle-info", iconType: CATEGORIES.SOLID }) }));
//# sourceMappingURL=InformationTooltip.js.map